module.exports = __webpack_public_path__ + "img/logo_6_sgn.3de34039.jpg";